
import {
	isWe88SeasonalPromotionSubsidiary,
	type We88SeasonalPromotionVariant,
} from './constants';

export interface We88SeasonalPromotionFlags {
	enableWorldCupFeverPopup?: boolean;
	enableFootballLeagueResumesPopup?: boolean;
	enableFootballLeagueFixtureFrenzyPopup?: boolean;
}

export const resolveWe88SeasonalVariant = (
	flags: We88SeasonalPromotionFlags,
	subsidiaryOpratorId?: string | null,
): We88SeasonalPromotionVariant | null => {
	if (!isWe88SeasonalPromotionSubsidiary(subsidiaryOpratorId)) {
		return null;
	}
	if (flags.enableFootballLeagueFixtureFrenzyPopup) {
		return 'fixture-frenzy';
	}
	if (flags.enableFootballLeagueResumesPopup) {
		return 'resumes';
	}
	if (flags.enableWorldCupFeverPopup) {
		return 'world-cup-fever';
	}
	return null;
};
